// removed by extract-text-webpack-plugin
module.exports = {"container":"join-meeting-section__container__hmKb_","cell-title":"join-meeting-section__cell-title__2we7M","spacer":"join-meeting-section__spacer__eXoPY","live-icon":"join-meeting-section__live-icon__S1H0i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/join-meeting-section.scss
// module id = 1340
// module chunks = 1